import React, { useState } from 'react';

import Button from 'shared/button';
import Modal from './modal';

export default function ShadowCreationButton() {
  const [showModal, setShowModal] = useState();

  return <React.Fragment>
    <Button.Primary onClick={() => setShowModal(true)}>
      New Grid
    </Button.Primary>

    {showModal && <Modal show onClose={() => setShowModal(false)} />}
  </React.Fragment>;
}
